import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/colt/cncl`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/colt/reus`,
    api_v1: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/fee`,
    nodes: [
        { path: "/", label: "Collection" },
        { path: "/colt", label: "Notice" },
        { path: "/colt/cncl", label: "Cancellation" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0403001q: `/osci/colt/cncl/osci0403001q`, // 고지 취소 목록 조회
    osci0403002q: `/osci/colt/cncl/osci0403002q`, // 고지 취소 상세 조회
    osci0403003s: `/osci/colt/cncl/osci0403003s`, // 고지 취소 내역 등록
    osci0403004q: `/osci/colt/cncl/osci0403004q`, // 고지 취소 목록 조회 for Cargo
    osci0403005q: `/osci/colt/cncl/osci0403005q`, // 고지 취소 상세 조회 for Cargo
    osci0403006s: `/osci/colt/cncl/osci0403006s`, // 고지 취소 내역 등록 for Cargo
    clri0801029q: `${process.env.REACT_APP_URL_CLRI}/info/dclr/clri0801029q`, // Declaration 처리이력 (팝업)
    osci0403007s: `/osci/colt/cncl/osci0403007s`, // Bill Detail !== 고지 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get Bill Cancellation List !== 고지 취소 목록 조회 ==!
    getBllReusList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/reusLst?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Bill Cancellation Detail !== 고지 취소 상세 조회 ==!
    getBllReusDtl: (data: any) => {
        return api.get(`${BASE.api}/bll`, {
            params: comnUtils.toGetParams(data),
        });
        // r
        // eturn api.get(`${BASE.api}/${billNo}/${cagRgsrYn}`);
    },
    // Get Bill Info !== 고지 정보 조회 ==!
    getBllDtlInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}/lpcoBll`);
    },
    // Get Bill Cancellation Detail Bill List !== 고지 취소 상세 고지서 목록 조회 ==!
    getBllReusDtlBllList: (tansadNo: any) => {
        return api.get(`${BASE.api}/bllList/${tansadNo}`);
    },
    // Save Bill Cancellation !== 고지 취소 저장 ==!
    saveBllReus: (dtlData: any, cnclData: any, mode: any) => {
        return api.post(`${BASE.api}/saveBllReus/${mode}`, {
            ...dtlData,
            ...cnclData,
        });
    },
    // Delete Bill Cancellation !== 고지 취소내역 삭제 ==!
    deleteBllReus: (bllMgmtId: any, reusRqstSn?: any) => {
        return api.delete(`${BASE.api}/deleteBllReus/${bllMgmtId}`, { params: { reusRqstSn } });
    },
    // Bill Cancellation Approval Request After !== 고지 취소 결재 상신 후처리 ==!
    bllReusAprvRqstAf: (data: any) => {
        return api.post(`${BASE.api}/bllReusAprvRqstAf`, {
            ...data,
        });
    },
    reusBll: (data: any) => {
        return api.post(`${BASE.api_v1}/reusBll`, {
            ...data,
        });
    },
    getExchageRate: (usd: any) => {
        console.log(`[APIS::getExchageRate] =======================`);
        return api.get(`${BASE.api_v1}/exrt`, {
            params: {},
        });
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명과 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */
//============================================================================================================================
// 목록
//============================================================================================================================
// 고지 취소 목록
export const SG_BLL_REUS_LIST: TGridSchema = {
    id: "form_bllReusList",
    options: {
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 500,
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: 160 }] },
        { cells: [{ header: "L_BLL_DT", binding: "bllDt", width: 120 }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_TXPR", binding: "pyerMgmtNo", width: 150 }] },
        { cells: [{ header: "L_DUE_DT", binding: "payDdlnDt", width: 100 }] },
        //{ cells: [{ header: "L_BLL_AMT", binding: "feeAmt", width: "*" }] },
        { cells: [{ header: "L_REUS_AMT", binding: "feeAmt", width: "*" }] },
        // { cells: [{ header: "L_REUS_CD", binding: "reusCd", width: 150 }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: 160 }] },
        { cells: [{ header: "L_REGST_NM", binding: "bllRgsrId", width: "*" }] },
        { cells: [{ header: "L_RGSR_DT", binding: "reusRqstDt", width: 120 }] },
        // { cells: [{ header: "L_RGST_ID", binding: "sbmsId", width: 120 }] },
        // { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 150 }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "reusStatCd", width: 170 }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllDt", type: "date" }] },
        { cells: [{ binding: "ctrlNo" }] },
        { cells: [{ binding: "pyerMgmtNo", mask: colUtils.getMaskPattern("tin") }] },
        { cells: [{ binding: "payDdlnDt", type: "date" }] },
        //{ cells: [{ binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" }] },
        {
            cells: [{ binding: "reusFeeAmt", type: "number", thousandSeparator: true, align: "right" }],
        },
        // { cells: [{ binding: "reusCd", type: "code", area: "comnCd", comnCd: "OSC0057" }] },
        { cells: [{ binding: "bllMgmtId", mask: colUtils.getMaskPattern("bllNo") }] },
        { cells: [{ binding: "bllRgsrId" }] },
        { cells: [{ binding: "reusRqstDt", type: "date" }] },
        // { cells: [{ binding: "sbmsId" }] },
        // { cells: [{ binding: "aprvPrcssStatCd", type: "code", area: "comnCd", comnCd: "OSC0096" }] },
        { cells: [{ binding: "reusStatCd", type: "code", area: "comnCd", comnCd: "OSC0251" }] },
    ],
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */

//============================================================================================================================
// 목록
//============================================================================================================================
// 고지 취소 목록 검색
export const SF_BLL_REUS_LIST_SRCH: TFormSchema = {
    id: "form_bllReusSrch",
    schema: {
        bllNo: {
            type: "text",
            label: "L_BLL_NO",
            letterCase: "upper",
        },
        bllCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: false,
        },
        txprTin: {
            type: "text",
            label: "L_TXPR_TIN",
            mask: colUtils.getMaskPattern("tin"),
        },
        reusDt: {
            type: "daterange",
            label: "L_REUS_DT",
            start: { name: "reusStrtDt" },
            end: { name: "reusEndDt" },
            rangeButton: 0,
            controlSize: 10,
        },
        aprvPrcssStatCd: {
            type: "select",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0096",
        },
        reusStatCd: {
            type: "select",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0251",
            all: true,
        },
    },
};

//============================================================================================================================
// 고지 취소 상세 검색
export const SF_BLL_REUS_DTL_SRCH: TFormSchema = {
    id: "form_bllReusDtlSrch",
    schema: {
        srchTp: {
            type: "radio",
            options: [
                { label: "Bill No", value: "B" },
                { label: "TANSAD No", value: "T" },
            ],
            defaultValue: "B",
        },
        bllMgmtId: {
            label: "L_BLL_MGMT_ID",
        },
        bllNo: {
            label: "L_BLL_NO",
        },
        bllSysmCd: {
            type: "text",
            size: 2,
            maxLength: 4,
        },
        bllYy: {
            type: "text",
            size: 1,
            maxLength: 2,
        },
        bllTpCd: {
            type: "text",
            size: 1,
            maxLength: 1,
            letterCase: "upper",
        },
        bllSrno: {
            type: "text",
            size: 3,
            maxLength: 7,
        },
        bllDgr: {
            type: "text",
            size: 1,
            maxLength: 1,
        },
        reffKeyNo: {
            type: "text",
        },
        reffKeyNo1: {
            type: "text",
            size: 2,
            maxLength: 4,
            letterCase: "upper",
            required: true,
        },
        reffKeyNo2: {
            type: "text",
            size: 1,
            maxLength: 2,
            required: true,
        },
        reffKeyNo3: {
            type: "text",
            size: 3,
            maxLength: 7,
            required: true,
        },
    },
};

// 고지 취소 상세
export const SF_BLL_REUS_DTL: TFormSchema = {
    id: "form_bllReusDtl",
    schema: {
        bllNo: {
            type: "text",
            label: "L_BLL_NO",
        },
        bllSysmCd: {
            type: "text",
            maxLength: 4,
        },
        bllYy: {
            type: "text",
            maxLength: 2,
        },
        bllTpCd: {
            type: "text",
            maxLength: 1,
        },
        bllSrno: {
            type: "text",
            maxLength: 7,
        },
        bllDgr: {
            type: "text",
            maxLength: 1,
        },
        bllDt: {
            type: "date",
            label: "L_BLL_DT",
        },
        ctrlNo: {
            type: "text",
            label: "L_CTRL_NO",
        },
        zmpDt: {
            type: "date",
            label: "L_ZMP_DT",
        },
        bllTpCdSec: {
            type: "code",
            label: "L_BLL_TP",
            area: "comnCd",
            comnCd: "OSC0058",
        },
        bllStatCd: {
            type: "code",
            label: "L_BLL_STAT",
            area: "comnCd",
            comnCd: "OSC0056",
        },
        pyerMgmtNo: {
            type: "text",
            label: "L_TXPR_TIN",
            mask: colUtils.getMaskPattern("tin"),
        },
        reffKey: {
            type: "text",
            label: "L_REFF_KEY",
        },
        reffKeyTpCd: {
            type: "code",
            label: "L_REFF_TP",
            area: "comnCd",
            comnCd: "OSC0067",
        },
        bllRgsrId: {
            type: "text",
            label: "L_RGSR",
        },
        currCd: {
            type: "select",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            edit: false,
        } /* Currency Code	!== 통화 코드 ==! */,
        feeAmt: {
            type: "number",
            label: "L_FEE_AMT",
            thousandSeparator: true,
            decimalScale: 2,
            align: "right",
        },
        feeTzsAmt: {
            type: "number",
            label: "L_FEE_AMT_TZS",
            thousandSeparator: true,
            decimalScale: 2,
            align: "right",
        },
        payDdlnDt: {
            type: "date",
            label: "L_DDLN_DT",
        },
        lastDdlnXtnsDt: {
            type: "text",
            label: "L_DDLN_XTNS_DT",
        },
        xtnsDt: {
            type: "number",
            label: "L_XTNS_DD",
        },
        lastDdlnXtnsRsn: {
            type: "text",
            label: "L_DDLN_XTNS_RSN",
        },
        reusRqstDt: {
            type: "date",
            label: "L_REUS_DT",
        },
        reusCd: {
            type: "code",
            label: "L_REUS_CD",
            area: "comnCd",
            comnCd: "OSC0203",
        },
        aprvPrcssStatCd: {
            type: "code",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0096",
        },
        reusStatCd: {
            type: "code",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0251",
        },
        reusRmrk: {
            type: "text",
            label: "L_REUS_RSN",
        },
        errRcveDt: {
            type: "datetime",
            label: "L_ERR_RCVE_DT",
        },
        errMsgCn: {
            type: "text",
            label: "L_ERR_CN",
        },
    },
};

//============================================================================================================================
// 고지 취소 저장/수정
//============================================================================================================================
// 고지 취소 상세
export const SF_REUS: TFormSchema = {
    id: "form_cncl",
    schema: {
        reusCdSave: {
            type: "select",
            label: "L_REUS_CD",
            area: "comnCd",
            comnCd: "OSC0203",
            select: true,
            required: true,
            excludes: ["M"],
        },
        reusRmrkSave: {
            type: "textarea",
            label: "L_RMRK",
            required: true,
            controlSize: 10,
        },
    },
};

// Schema of Bill List Grid !== 고지 목록 그리드 스키마 ==!
export const SG_BLL_REUS_DTL_LIST: TGridSchema = {
    id: "grid_blldDtlList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: 180 }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: 180 }] },
        { cells: [{ header: "L_BLL_DT", binding: "bllDt", width: 100 }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_BLL_AMT", binding: "feeAmt", width: "*" }] },
        { cells: [{ header: "L_DUE_DT", binding: "lastPayDdlnDt", width: 100 }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllMgmtId" }] },
        { cells: [{ binding: "bllDt", type: "date" }] },
        { cells: [{ binding: "ctrlNo" }] },
        { cells: [{ binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "lastPayDdlnDt", type: "date" }] },
    ],
};
// 고지 취소 상세 > 고지목록
export const SG_BLL_REUS_DTL_BLL_LIST: TGridSchema = {
    id: "form_bllReusDtlBllList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: "*" }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: "*" }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_BLL_AMT", binding: "feeAmt", width: "*" }] },
        { cells: [{ header: "L_BLL_EQV_AMT", binding: "feeTzsAmt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllMgmtId", mask: colUtils.getMaskPattern("bllNo") }] },
        { cells: [{ binding: "ctrlNo" }] },
        { cells: [{ binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "feeTzsAmt", type: "number", thousandSeparator: true, align: "right" }] },
    ],
};

export const SG_BLL_ITM_LIST: TGridSchema = {
    id: "grid_blldDtlList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: "*" }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: "*" }] },
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: "*" }] },
        { cells: [{ header: "L_ITM_NM", binding: "itmNm", width: "2*" }] },
        { cells: [{ header: "L_AMT", binding: "bllItmAmt", width: "*" }] },
        { cells: [{ header: "L_EQV_AMT", binding: "bllItmTzsAmt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllMgmtId", mask: colUtils.getMaskPattern("bllNo") }] },
        { cells: [{ binding: "gfsCd" }] },
        { cells: [{ binding: "itmNm", align: "left" }] },
        { cells: [{ binding: "bllItmAmt", type: "number", thousandSeparator: true, align: "right" }] },
        {
            cells: [{ binding: "bllItmTzsAmt", type: "number", thousandSeparator: true, align: "right" }],
        },
    ],
};
